import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useConfirmVerification = () => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useMutation(
    (payload: any) =>
      axiosInstance
        .put("/tutors/verification", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    {}
  );
};
